import * as React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useMemberProducts } from "@nju/data-access-portal-product";
import { pushSimpleEvent } from "@nju/data-layer";
import { portalRoutes } from "@nju/routes";
import {
  A,
  Button,
  GeneralErrorNotification,
  Panel,
  Separator,
  Text,
} from "@nju/ui";
import { MySimCardBlockSuccess } from "./MySimCardBlockSuccess";
import { mySimCardToggleBlockMachine } from "./mySimCardToggleBlock.machine";

export function MySimCardBlock() {
  const router = useRouter();
  const params = portalRoutes.mojeKonto.mojaKarta.blokowanieKartySim
    .input(router.query)
    .unwrap();
  const { mobileProducts } = useMemberProducts();
  const productId = mobileProducts.mobileAccess?.id;

  const [current, send] = useMachine(mySimCardToggleBlockMachine, {
    context: {
      productId,
      action: undefined,
    },
  });

  const { matches } = current;

  const blockSimCard = React.useCallback(() => {
    pushSimpleEvent({
      event: "activity_sim_status",
      eventName: "block_sim_resignation_confirmed",
    });
    send({ type: "BLOCK" });
  }, [send]);

  if (!mobileProducts) {
    // eslint-disable-next-line unicorn/no-null
    return null;
  }

  if (matches("success")) {
    return <MySimCardBlockSuccess userId={params?.userId} />;
  }

  if (matches("error")) {
    return (
      <GeneralErrorNotification
        callback={() => {
          return window.location.reload();
        }}
      />
    );
  }

  return (
    <Panel testId="sim-card-block-panel">
      <Text
        size={{
          "@onlyMobile": "xl",
          "@fromTablet": "keyM",
        }}
        weight="bold"
      >
        blokowanie karty SIM
      </Text>
      <Separator size="s" />
      <Text>
        Blokadę karty SIM zgłoś w przypadku{" "}
        <b>zgubienia lub kradzieży telefonu.</b>
        <Separator size="s" tone="invisible" />
        Zablokowanie karty SIM oznacza, że{" "}
        <b>
          połączenia, SMS-y i MMS-y oraz transmisja danych zostaną zablokowane.
        </b>{" "}
        Nie zwalnia Cię to jednak z opłat za usługę.
        <Separator size="s" tone="invisible" />
        Pamiętaj, że w dowolnym momencie możesz odblokować swoją kartę SIM.
      </Text>
      <Separator size="s" tone="invisible" />
      <div className="flex justify-between only-mobile:gap-3 only-mobile:flex-col-reverse flex-row">
        <Link
          href={portalRoutes.mojeKonto.mojaKarta.index.get({
            ...(params?.userId && { userId: params.userId }),
          })}
          passHref={true}
        >
          <A
            size={{
              "@onlyMobile": "s",
            }}
            variant="secondary"
          >
            anuluj
          </A>
        </Link>
        <Button
          isLoading={matches("setBlockSimCard")}
          onPress={blockSimCard}
          size={{ "@onlyMobile": "s" }}
        >
          zablokuj kartę
        </Button>
      </div>
    </Panel>
  );
}
